export default "__VITE_ASSET__BBItT0EN__"